import { render } from "./FuturesBalanceActionGraphWidgetParams.vue?vue&type=template&id=6bc1f42b"
import script from "./FuturesBalanceActionGraphWidgetParams.vue?vue&type=script&lang=js"
export * from "./FuturesBalanceActionGraphWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script